import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HttpClientModule } from '@angular/common/http';
import { CustomToastComponent } from './component/custom-toast/custom-toast.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { spriteSvg } from './svg-icons/empty-state/sprite-svg';
import { FileUploadComponent } from './component/file-upload/file-upload.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BreadcrumbsComponent } from './component/breadcrumbs/breadcrumbs.component';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AddSpaceBeforeUppercasePipe } from './pipe/table-column';
import { TokenService } from './service/token.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OrgAppTableSkeletonComponent } from './component/org-app-table-skeleton/org-app-table-skeleton.component';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerComponent } from './component/spinner/spinner.component';
import { ManageDialogComponent } from './component/manage-dialog/manage-dialog.component';
import { TablePaginationComponent } from './component/table-pagination/table-pagination.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ZoomSliderComponent } from './component/zoom-slider/zoom-slider.component';
import { MatSliderModule } from '@angular/material/slider';
import { UserLocationService } from './service/user-location.service';
import { CustomTableComponent } from './component/custom-table/custom-table.component';
import { ScaleService } from './service/scale.service';
import { TimerService } from './service/timer.service';
import { TimeConversionService } from './service/time-conversion.service';
import { LocalUtcDateService } from './service/local-utc-date.service';
import { CapitalizePipe } from './pipe/string-format';
import { FileDragNDropDirective } from './custom-directive/file-drag-n-drop-directive';
import {
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  DragDropModule,
} from '@angular/cdk/drag-drop';
import { MatRadioModule } from '@angular/material/radio';
import { PhoneValidatorDirective } from './custom-directive/country-code-directive';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { UploadPhotoComponent } from './component/upload-photo/upload-photo.component';
import { DutyListComponent } from './component/duty-list/duty-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PlanningHeaderData } from './service/planning-header-data';
import { PlanningDataService } from './service/planning-data.service';
import { EmptyPlanComponent } from './component/empty-plan/empty-plan.component';
import { MonthPickerComponent } from './component/month-picker/month-picker.component';
import { MonthTitleCasePipe } from './pipe/month-title-case.pipe';
import { PlanningEventTempComponent } from './component/planning-sheet/planning-event-temp/planning-event-temp.component';
import { DatePickerComponent } from './component/date-picker/date-picker.component';
import { HighlightTextPipe } from './pipe/highlight-text.pipe';
import { NgxPrintModule } from 'ngx-print';
import { LoginMobileNoDirective } from './custom-directive/login-mobile-no.directive';
import { NgOtpInputModule } from 'ng-otp-input';
import { ChangePasswordComponent } from '../modules/settings/manage-profile/change-password/change-password.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ValueSelectorPopupComponent } from './component/value-selector-popup/value-selector-popup.component';
import { FallbackImageDirective } from './custom-directive/fallback-image.directive';
import { IconColorPickerComponent } from './component/icon-color-picker/icon-color-picker.component';
@NgModule({
  declarations: [
    CustomToastComponent,
    spriteSvg,
    FileUploadComponent,
    BreadcrumbsComponent,
    OrgAppTableSkeletonComponent,
    SpinnerComponent,
    ManageDialogComponent,
    TablePaginationComponent,
    ZoomSliderComponent,
    FileDragNDropDirective,
    CustomTableComponent,
    PhoneValidatorDirective,
    UploadPhotoComponent,
    DutyListComponent,
    EmptyPlanComponent,
    MonthPickerComponent,
    MonthTitleCasePipe,
    PlanningEventTempComponent,
    DatePickerComponent,
    HighlightTextPipe,
    LoginMobileNoDirective,
    ChangePasswordComponent,
    ValueSelectorPopupComponent,
    FallbackImageDirective
  ],
  imports: [
    CommonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatSnackBarModule,
    HttpClientModule,
    TranslateModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatSelectModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonToggleModule,
    AddSpaceBeforeUppercasePipe,
    MatDialogModule,
    MatChipsModule,
    MatAutocompleteModule,
    NgxSkeletonLoaderModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSliderModule,
    CapitalizePipe,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    DragDropModule,
    MatRadioModule,
    MatCardModule,
    ImageCropperComponent,
    MatSlideToggleModule,
    NgxPrintModule,
    NgOtpInputModule,
    MatCheckboxModule,
    IconColorPickerComponent
  ],
  exports: [
    CommonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatProgressBarModule,
    CustomToastComponent,
    spriteSvg,
    FileUploadComponent,
    OrgAppTableSkeletonComponent,
    MatDatepickerModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbsComponent,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatSelectModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonToggleModule,
    AddSpaceBeforeUppercasePipe,
    MatChipsModule,
    MatAutocompleteModule,
    NgxSkeletonLoaderModule,
    OrgAppTableSkeletonComponent,
    MatTableModule,
    MatProgressSpinnerModule,
    SpinnerComponent,
    TranslateModule,
    TablePaginationComponent,
    MatPaginatorModule,
    CustomTableComponent,
    CapitalizePipe,
    FileDragNDropDirective,
    ZoomSliderComponent,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    DragDropModule,
    MatRadioModule,
    PhoneValidatorDirective,
    MatCardModule,
    ImageCropperComponent,
    MatSlideToggleModule,
    MatCheckboxModule,
    DutyListComponent,
    EmptyPlanComponent,
    MonthPickerComponent,
    MonthTitleCasePipe,
    PlanningEventTempComponent,
    DatePickerComponent,
    HighlightTextPipe,
    NgxPrintModule,
    LoginMobileNoDirective,
    NgOtpInputModule,
    ChangePasswordComponent,
    ValueSelectorPopupComponent,
    FallbackImageDirective
  ],
  providers: [
    TokenService,
    UserLocationService,
    ScaleService,
    TimerService,
    TimeConversionService,
    LocalUtcDateService,
    PlanningHeaderData,
    PlanningDataService
  ],
})
export class SharedModule {}
